define('container/argResolvers/PlatformValidationRuleArgResolver',['underscore', 'bluebird'], function(_, Promise) {

    'use strict';

    /**
     * @param {String} definitionPrefix
     * @param {Function} ruleFactory
     * @param {String} dispatcherConstructorServiceId
     */
    function CommandArgResolver(definitionPrefix, ruleFactory, dispatcherConstructorServiceId) {
        this.definitionPrefix = definitionPrefix;
        this.ruleFactory = ruleFactory;
        this.dispatcherConstructorServiceId = dispatcherConstructorServiceId;
    }

    CommandArgResolver.prototype.canResolveArg = function(argDefinition) {
        return argDefinition.substring(0, this.definitionPrefix.length) === this.definitionPrefix;
    };

    CommandArgResolver.prototype.resolveArg = function(argDefinition, extensionApi) {

        var parts = _.tail(argDefinition.split(':'));

        return extensionApi.container.get(this.dispatcherConstructorServiceId).then(function(Dispatcher) {
            return this.ruleFactory(parts[0], new Dispatcher(parts[1], parts[2]));
        }.bind(this));
    };

    return CommandArgResolver;
});

